<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";
/**
 * Basic-table component
 */
export default {
  components: { ErrorMessage, Layout, PageHeader },
  data() {
    return {
      title: "Airports List",
      items: [
        {
          text: "Airports",
          href: "/",
        },
        {
          text: "List",
          active: true,
        },
      ],
      airports: [],
        search_city:"",
        search_airport_code:"",
        search_airport_name:"",
        search_country:"",
        search_country_code:"",
        search_world_area_code:"",
        errors:null,
        visible:false,
        message:"",
        search:"",
    };
  },
  mounted() {
    this.getAirportsList();
  },
    computed: {
        filteredList() {
            return this.airports.filter(airport => {
                return airport.city.toLowerCase().includes(this.search_city.toLowerCase())
                    && airport.airportCode.toLowerCase().includes(this.search_airport_code.toLowerCase())
                    && airport.airportName.toLowerCase().includes(this.search_airport_name.toLowerCase())
                    && airport.countryCode.toLowerCase().includes(this.search_country.toLowerCase())
                    && airport.country.toLowerCase().includes(this.search_country_code.toLowerCase())
                    && airport.worldAreaCode.toLowerCase().includes(this.search_world_area_code.toLowerCase())
            })
        }
    },

    methods: {
      onClose(){
          this.visible=false;
      },
        searchFilterFunc2(val) {
            this.search=val;
        },

    async deleteWarning(bockList) {
      var _this = this;
      try {
        this.$swal({
          title: "Are you sure?",
          text: "You can't revert your action",
          type: "error",
          showCancelButton: true,
          confirmButtonText: "Yes, Delete it!",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            _this.deleteItem(bockList);
          } else {
            this.$swal("Cancelled", "", "info");
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    async getAirportsList() {
        var _this = this;
      try {
        axios
          .get("/api/airport-list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              _this.airports = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (obj.message !== "Token has expired") {
        this.errors = obj.message;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    deleteItem: function deleteItem(airports) {
      var _this = this;
      axios
        .post("/api/airport-delete/" + airports.id, {
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then(function (response) {
          if(response.data.status){
              _this.getAirportsList();
              _this.hasDeleted = false;
          } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              _this.errorCheck(jsonParse);
          }
        });
    },
  },
};
</script>

<template>
  <Layout   @CustomEventInputChangedAll="searchFilterFunc2">
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive table-responsive-sm">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>SL</th>
                    <th>City</th>
                    <th>Airport Code</th>
                    <th>Airport Name</th>
                      <th>Country</th>
                      <th>Country Code</th>
                      <th>World Area Code</th>
                    <th>Action</th>
                  </tr>
                  <tr>
                      <td> &nbsp </td>
                      <td><input type="text" class="app-search form-control" v-model="search_city" placeholder="Search" /></td>
                      <td><input type="text" class="app-search form-control" v-model="search_airport_code" placeholder="Search" /></td>
                      <td><input type="text" class="app-search form-control" v-model="search_airport_name" placeholder="Search" /></td>
                      <td><input type="text" class="app-search form-control" v-model="search_country" placeholder="Search" /></td>
                      <td><input type="text" class="app-search form-control" v-model="search_country_code" placeholder="Search" /></td>
                      <td><input type="text" class="app-search form-control" v-model="search_world_area_code" placeholder="Search" /></td>
                      <td> </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(airport,index) in filteredList" v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                    <td>{{airport.city == null ? 'N/A' : airport.city}}</td>
                    <td>{{ airport.airportCode == null ? 'N/A' : airport.airportCode }}</td>
                      <td>{{airport.airportName == null ? 'N/A' : airport.airportName}}</td>
                      <td>{{ airport.countryCode == null ? 'N/A' : airport.countryCode }}</td>
                      <td>{{airport.country == null ? 'N/A' : airport.country}}</td>
                      <td>{{ airport.worldAreaCode == null ? 'N/A' : airport.worldAreaCode }}</td>
                    <td><router-link :to="{ name: 'airport_update', params: {id: airport.id } }" class="btn btn-primary btn-small"><i class="fas fa-edit"></i> Edit</router-link> <button @click.prevent="deleteWarning(airport)" class="btn btn-danger btn-small"><i class="fa fa-trash"></i> Delete</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
